// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1l5VX","colMin":"styles_colMin__2zyEO","colCheckbox":"styles_colCheckbox__1iuIH"};